import { ServiceHistory } from './serviceHistory.models';

export interface ServiceHistoryState {
  ids: string[];
  entities: Record<string, ServiceHistory[]>;
  selectedAppointmentId: string | null;
  error: string | null;
  isLoaded: boolean;
  isLoading: boolean;
}

type Action =
  | { type: 'FETCH_SERVICE_HISTORY'; payload: { appointmentId: string } }
  | {
      type: 'FETCH_SERVICE_HISTORY_SUCCESS';
      payload: {
        appointmentId: string;
        serviceHistory: ServiceHistory[];
      };
    }
  | { type: 'FETCH_SERVICE_HISTORY_FAILURE'; payload: { error: string } }
  | { type: 'FETCH_SERVICE_HISTORY_CANCELLED' }
  | {
      type: 'SET_LOADING_STATE';
      payload: { isLoading: boolean; isLoaded: boolean };
    };

export const initState: ServiceHistoryState = {
  ids: [],
  entities: {},
  selectedAppointmentId: null,
  error: null,
  isLoaded: false,
  isLoading: true,
};

export const serviceHistoryReducer = (
  state: ServiceHistoryState,
  action: Action
): ServiceHistoryState => {
  switch (action.type) {
    case 'FETCH_SERVICE_HISTORY':
      return {
        ...state,
        error: null,
        isLoading: true,
        isLoaded: state.ids.includes(action.payload.appointmentId),
        selectedAppointmentId: action.payload.appointmentId,
      };

    case 'FETCH_SERVICE_HISTORY_SUCCESS':
      return {
        ...state,
        isLoading: false,
        isLoaded: true,
        ids: [...new Set([...state.ids, action.payload.appointmentId])],
        entities: {
          ...state.entities,
          [action.payload.appointmentId]: action.payload.serviceHistory,
        },
      };

    case 'FETCH_SERVICE_HISTORY_FAILURE':
      return {
        ...state,
        isLoading: false,
        isLoaded: false,
        error: action.payload.error,
      };

    case 'FETCH_SERVICE_HISTORY_CANCELLED':
      return {
        ...state,
        error: null,
      };

    case 'SET_LOADING_STATE':
      return { ...state, ...action.payload };

    default:
      return state;
  }
};
